<template>
  <div>
    <!-- tab -->
    <div class="tab">
      <div
        v-for="(item, index) in tab.items"
        :key="item.title"
        class="tab-title"
        :class="tab.active == index ? 'tab-title-active' : ''"
        @click="activeHook(index, tab.active)"
      >
        {{ item.title }}
      </div>
    </div>

    <!-- tab-blank -->
    <div class="tab-blank" />

    <!-- content -->
    <div
      class="content"
      :style="{ height: contentHeight }"
    >
      <transition-group
        mode="out-in"
        :name="animate"
      >
        <!-- 主页 -->
        <div
          v-show="tab.active == 0"
          key="homePage"
          class="homePage"
        >
          <van-pull-refresh
            v-model="homePage.refreshing"
            @refresh="homePageRefresh"
          >
            <van-list
              v-model="homePage.loading"
              :finished="homePage.finished"
              finished-text="没有更多了"
              :immediate-check="false"
              @load="homePageList_load"
            >
              <div
                v-for="item in homePage.list"
                ref="homePageCard"
                :key="item.id"
                class="homePageCard"
                @click="linkTo(item.link, item.id)"
              >
                <div class="homePageCard-info">
                  <div class="homePageCard-title van-ellipsis">{{ item.title }}</div>
                  <div class="homePageCard-author van-ellipsis">投稿：{{ item.author }}</div>
                  <div class="homePageCard-introduction">{{ item.introduction }}</div>
                </div>
                <div
                  v-lazy:background-image="$imgHook(item.cover)"
                  class="homePageCard-cover"
                />
              </div>
            </van-list>
          </van-pull-refresh>
        </div>

        <!-- 文章 -->
        <div
          v-show="tab.active == 1"
          key="article"
          class="article"
        >
          <van-pull-refresh
            v-model="article.refreshing"
            @refresh="articleRefresh"
          >
            <van-list
              v-model="article.loading"
              :finished="article.finished"
              finished-text="没有更多了"
              :immediate-check="false"
              @load="articleList_load"
            >
              <div
                v-for="item in article.list"
                ref="articleCard"
                :key="item.id"
                class="articleCard"
              >
                <div
                  v-lazy:background-image="$imgHook(item.cover)"
                  class="articleCard-A-cover"
                  @click="linkTo(item.link, item.id)"
                />
                <div
                  class="articleCard-A-info"
                  @click="linkTo(item.link, item.id)"
                >
                  <div class="articleCard-A-title">{{ item.title }}</div>
                  <div class="articleCard-A-introduction">{{ item.introduction }}</div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>

        <!-- 滑块 -->
      </transition-group>
    </div>
  </div>
</template>

<script>
import { PullRefresh } from 'vant'
import { linkTo } from '~/utils/func'

export default {
  name: 'Other',
  components: {
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      animate: 'slide-left',
      tab: {
        active: 0,
        items: [
          {
            title: '主页',
            tabRef: 'homePageTab',
            listRef: 'homePageCard',
            to: ''
          },
          {
            title: '文章',
            tabRef: 'articleTab',
            listRef: 'articleCard',
            to: ''
          }
        ]
      },
      homePage: {
        currentPage: 0,
        loading: false,
        finished: false,
        refreshing: false,
        requesting: false,
        list: []
      },
      article: {
        currentPage: 0,
        loading: false,
        finished: false,
        refreshing: false,
        requesting: false,
        list: []
      }
    }
  },
  computed: {
    contentHeight() {
      // 有坑，区分px与rpx与vw
      const height = this.$clientHeight
      return (this.$pxToVw(height) - this.$rpxToVw(110)) + 'vw'
    }
  },
  activated() {
    // 绑定双击tab回到顶部
    // const elms = []
    // const fingers = []
    // const that = this
    // for (let i = 0; i < this.tab.items.length; i++) {
    //   const tabRef = this.tab.items[i].tabRef
    //   elms[i] = this.$refs[tabRef][0]
    //   fingers[i] = new this.$finger(elms[i], {
    //     tap() {
    //       that.activeHook(i, that.tab.active)
    //     },
    //     doubleTap() {
    //       that.scrollToTop(that.tab.items[i].listRef)
    //     }
    //   })
    // }
    this.homePageList_load()
  },
  methods: {
    // 跳转
    linkTo,
    // 监听 tab 切换时的active
    activeHook(newValue, oldValue) {
      if (newValue > oldValue) {
        this.animate = 'slide-left'
      } else {
        this.animate = 'slide-right'
      }
      this.$set(this.tab, 'active', newValue)
      switch (newValue) {
        case 0:
          this.homePage.list.length === 0 && this.homePageList_load()
          break
        case 1:
          this.article.list.length === 0 && this.articleList_load()
          break
        case 2:
          break
        default:
          break
      }
    },
    // 重置主页所有状态数据(除了refreshing)
    // 坑: finished从true变回false会立即加载一次
    homePageReset() {
      this.$set(this.homePage, 'currentPage', 0)
      this.$set(this.homePage, 'list', [])
      this.$set(this.homePage, 'loading', false)
      this.$set(this.homePage, 'finished', false)
    },
    // 刷新主页列表
    homePageRefresh() {
      const isFinished = this.homePage.finished
      this.homePageReset()
      !isFinished && this.homePageList_load()
    },
    // 主页列表加载
    homePageList_load() {
      if (this.homePage.finished || this.article.requesting) {
        return
      }
      this.$set(this.article, 'requesting', true)
      this.$set(this.homePage, 'currentPage', this.homePage.currentPage + 1)
      this.$api.homePage.findAll({ page: this.homePage.currentPage }).then(res => {
        const data = res.data
        this.$set(this.article, 'requesting', false)
        this.$set(this.homePage, 'loading', false)
        // 刷新成功
        if (this.homePage.refreshing) {
          this.$toast.success('刷新成功')
          this.$set(this.homePage, 'refreshing', false)
        }
        this.homePage.list = this.homePage.list.concat(data)
        if (!data || data.length < 20) {
          this.$set(this.homePage, 'finished', true)
        }
      }).catch(() => {
        if (this.homePage.refreshing) {
          this.$toast.fail('刷新失败')
          this.$set(this.homePage, 'refreshing', false)
        } else {
          this.$toast.fail('加载列表失败')
        }
        this.$set(this.homePage, 'loading', false)
      })
    },
    // 重置主页所有状态数据(除了refreshing)
    // 坑: finished从true变回false会立即加载一次
    articleReset() {
      this.$set(this.article, 'currentPage', 0)
      this.$set(this.article, 'list', [])
      this.$set(this.article, 'loading', false)
      this.$set(this.article, 'finished', false)
    },
    // 文章刷新
    articleRefresh() {
      const isFinished = this.article.finished
      this.articleReset()
      !isFinished && this.articleList_load()
    },
    // 文章加载
    articleList_load() {
      if (this.article.finished || this.article.requesting) {
        return
      }
      this.$set(this.article, 'requesting', true)
      this.$set(this.article, 'currentPage', this.article.currentPage + 1)
      this.$api.article.findAll({ page: this.article.currentPage }).then(res => {
        this.$set(this.article, 'requesting', false)
        this.$set(this.article, 'loading', false)
        const data = res.data
        // 刷新成功
        if (this.article.refreshing) {
          this.$toast.success('刷新成功')
          this.$set(this.article, 'refreshing', false)
        }
        this.article.list = this.article.list.concat(data)
        if (!data || data.length < 20) {
          this.$set(this.article, 'finished', true)
        }
      }).catch(() => {
        if (this.article.refreshing) {
          this.$toast.fail('刷新失败')
          this.$set(this.article, 'refreshing', false)
        } else {
          this.$toast.fail('加载列表失败')
        }
        this.$set(this.article, 'loading', false)
      })
    },
    // 双击回到顶部
    scrollToTop(ref) {
      if (!this.$refs || !this.$refs[ref] || !(this.$refs[ref].length > 0)) {
        return
      }
      this.$refs[ref][0].scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      })
    }
  }
}
</script>

<style scoped>

/* tab */
.tab {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 375px;
    height: 50px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    background-color: var(--light100);
}
.tab-title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    font-size: 18px;
    font-weight: 900;
    margin-left: 15px;
    height: 100%;
    box-sizing: border-box;
    color: var(--light60);
}
.tab-title-active {
    color: var(--textColor);
}
.tab-title-active::after {
    content: '';
    position: absolute;
    top: 0;
    left: 10px;
    width: 30px;
    height: inherit;
    box-sizing: border-box;
    border-bottom: 3px solid var(--textColor);
}
.tab-blank {
    width: 375px;
    height: 50px;
}

/* content */
.content {
    width: 375px;
    background: var(--light100);
}

/* homePage */
.homePage,
.article {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}
.homePageCard {
    display: flex;
    justify-content: space-between;
    width: 345px;
    height: 192px;
    border-radius: 8px;
    margin-top: 15px;
    margin-left: 15px;
    background-color: var(--light100);
    box-shadow: var(--boxShadow-bottom);
    box-sizing: border-box;
    padding: 11px;
}
.homePageCard-info {
    width: 180px;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.homePageCard-cover {
    width: 96px;
    height: 170px;
    background-repeat: no-repeat;
    background-size: 100% auto;
    border-radius: 6px;
}
.homePageCard-title {
    font-size: 16px;
    font-weight: 900;
    width: 100%;
}
.homePageCard-author {
    font-size: 14px;
    color: var(--light50);
    font-weight: 900;
    width: 100%;
    margin-top: 15px;
}
.homePageCard-introduction {
    font-size: 15px;
    margin-top: 15px;
    color: var(--light60);
}

/* article */
.articleCard {
    display: flex;
    flex-direction: column;
    width: 345px;
    border-radius: 8px;
    margin-top: 30px;
    margin-left: 15px;
    background-color: var(--light100);
    box-shadow: var(--boxShadow-bottom);
    box-sizing: border-box;
    overflow: hidden;
}
.articleCard:first-child {
    margin-top: 15px;
}
/* 文章样式A */
.articleCard-A-cover {
    width: 100%;
    height: 145px;
    background-repeat: no-repeat;
    background-size: 100% auto;
}
.articleCard-A-info {
    display: flex;
    flex-direction: column;
    background-color: var(--light100);
    width: 100%;
    box-sizing: border-box;
    padding: 11px;
}
.articleCard-A-title {
    font-size: 15px;
}
.articleCard-A-introduction {
    font-size: 12px;
    color: var(--light60);
    margin-top: 8px;
}

/* 动画 */
.slide-left-enter-active {
    animation: fadeInRight .1s forwards;
}

.slide-left-leave-active {
    animation: fadeOutLeft .2s forwards;
}
 .slide-right-enter-active {
    animation: fadeInLeft .1s forwards;
}

.slide-right-leave-active {
    animation: fadeOutRight .2s forwards;
}
</style>
